import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from 'inversify';
import { Symbols } from '../symbols';
import { format } from '@/@core/utils/string';
let CooperativeCompanyService = class CooperativeCompanyService {
    constructor(urls, http) {
        this.urls = urls;
        this.http = http;
        this.getCooperativeCompanyList = (params) => {
            const url = this.urls.getCooperativeCompanyList;
            return this.http.request({
                url,
                method: 'get',
                params,
            });
        };
    }
    // 获取公司名
    getCompaniesSolr(params) {
        const url = this.urls.getCompaniesSolr;
        return this.http.request({
            url,
            method: 'get',
            params,
        });
    }
    getCooperativeCompany(cooperative_company_id) {
        const url = format(this.urls.getCooperativeCompany, {
            cooperative_company_id,
        });
        return this.http.request({
            url,
        });
    }
    postEditCooperativeCompany(params) {
        const url = format(this.urls.postEditCooperativeCompany, {
            cooperative_company_id: params.id,
        });
        return this.http.request({
            url,
            method: 'post',
            data: params,
        });
    }
    postBatchEditCooperativeCompanies(params) {
        const url = this.urls.postBatchEditCooperativeCompanies;
        return this.http.request({
            url,
            method: 'post',
            data: params,
        });
    }
    postBatchAddCooperativeCompanies(params) {
        const url = this.urls.postBatchAddCooperativeCompanies;
        return this.http.request({
            url,
            method: 'post',
            data: params,
        });
    }
};
CooperativeCompanyService = __decorate([
    injectable(),
    __param(0, inject(Symbols.CooperativeCompanyServiceUrls)),
    __param(1, inject(Symbols.BoHttp)),
    __metadata("design:paramtypes", [Object, Object])
], CooperativeCompanyService);
export { CooperativeCompanyService };
